import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 1873 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1873 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\"><path d=\"M1691.899 999.044a79.681 79.681 0 0 0 5.946-112.47L923.461 26.391A79.511 79.511 0 0 0 861.279.058a79.511 79.511 0 0 0-62.182 26.334L24.543 886.573A79.681 79.681 0 1 0 142.96 993.098l718.32-797.66 718.148 797.66c29.562 32.62 79.85 35.338 112.47 5.946z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol